import React from 'react'
import { useWeb3React } from '@web3-react/core'
import { Flex, LogoutIcon, useModal, UserMenu as UIKitUserMenu, UserMenuDivider, UserMenuItem } from 'uikit'
import useAuth from 'hooks/useAuth'
import ConnectWalletButton from 'components/ConnectWalletButton'
import { FetchStatus, useGetBnbBalance } from 'hooks/useTokenBalance'
import { useTranslation } from 'contexts/Localization'
import WalletModal, { LOW_BNB_BALANCE, WalletView } from './WalletModal'
import WalletUserMenuItem from './WalletUserMenuItem'

const UserMenu = () => {
  const { t } = useTranslation()
  const { account } = useWeb3React()
  const { logout } = useAuth()
  const { balance, fetchStatus } = useGetBnbBalance()
  const [ onPresentWalletModal ] = useModal( <WalletModal initialView={ WalletView.WALLET_INFO }/> )
  const [ onPresentTransactionModal ] = useModal( <WalletModal initialView={ WalletView.TRANSACTIONS }/> )
  const hasLowBnbBalance = fetchStatus === FetchStatus.SUCCESS && balance.lte( LOW_BNB_BALANCE )

  if ( !account ) {
    return <ConnectWalletButton scale="sm"/>
  }

  return (
    <UIKitUserMenu account={ account } avatarSrc={ null }>
      <WalletUserMenuItem hasLowBnbBalance={ hasLowBnbBalance } onPresentWalletModal={ onPresentWalletModal }/>
      <UserMenuItem as="button" onClick={ onPresentTransactionModal }>
        { t( 'Transactions' ) }
      </UserMenuItem>
      <UserMenuDivider/>
      <UserMenuItem as="button" onClick={ logout }>
        <Flex alignItems="center" justifyContent="space-between" width="100%">
          { t( 'Disconnect' ) }
          <LogoutIcon/>
        </Flex>
      </UserMenuItem>
    </UIKitUserMenu>
  )
}

export default UserMenu
